<template>
	<div id="indexpage" v-title :data-title="title" style="height:100%;">
		<leftnav mkcode="D" itemcode="D-ZSHJ" :smScrennFull="true"></leftnav>
		<!-- 弹框 -->
		<div class="por" style="background-color: #041034;min-height:953px;height: 100vh;">
			<!-- 全屏开始 -->
			<i class="el-icon-full-screen swiper_fullscreen" @click="screen()"></i>
			<!-- 全屏结束 -->
			<div class="index-swiper centerpage">
				<!-- <h2 class="title dataswipertitle" @mouseover="drawer = true" >{{userdata.cityText}}</span>{{title}}<i class="el-icon-arrow-down dataswipertitle_icon"></i></h2> -->
				<navIcn :title="title" :indexnum="6" navcode="LAND" :fulltitle="true" @yearChange="yearChange"></navIcn>
				<div class="indexflex zhaoshangmap">
					<div class="col2h  zsxm_left">
						<div class="zsxm_province">
							<h3 class="zsxm_title">重点来源省份 </h3>
							<div class="zsxm_nav">
							</div>
							<div id="zsxm_province_money"  :style="'height:'+chartsHeight + 'px'">金额占比图表</div>
						</div>
						<div class="zsxm_city">
							<h3 class="zsxm_title">重点来源城市</h3>
							<div id="zsxm_city_money"  :style="'height:'+chartsHeight + 'px'">222</div>
						</div>
					</div>
					<div class="col5 colbox">
						<div id="zsxm_map"></div>
					</div>
					<div class="col2h colbox transparentbg">
						<div class="zsxm_industry">
							<h3 class="zsxm_title">接收企业拿地投资行业分布</h3>
							<div id="zsxm_industry_money"  :style="'height:'+chartsHeight + 'px'"></div>
						</div>
						<div class="">
							<h3 class="zsxm_title">接收企业拿地面积全省排名</h3>
							<div id="zsxm_provincerank"  :style="'height:'+chartsHeight + 'px'"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>
<script>

import navIcn from "@/components/dataswiper-sass/HNZYB/navIcn.vue";
import { sortKey } from "@/utils/index.js";
export default {
	components: { navIcn },
	name: 'zhaoshangditu',
	data() {
		return {
			isCollapse: false,
			isFullscreen: false,
			direction: "ltr",  //btt
			direction2: "btt",  //btt
			drawer: false,
			drawer2: false,
			modal: false,
			title: "全国企业在湖南拿地投资",
			bgcolor: "#041034",
			usernotionlistsave: [],
			userdata: {},
			mapurl: 'map/city/321200.json',
			contodefault: {
				duration: 1000,
				autoplay: true,
			},
			islogin: false,
			flag: true,
			swipernum: 3,
			zsxm_nav: 1,
			city_nav: 1,
			pro_nav: 1,
			listdata: [],
			public_tooltip: {
				trigger: 'axis',
				backgroundColor: 'rgba(255,255,255,0.9)',
				borderColor: '#ddd',
				borderWidth: '1',
				textStyle: {
					color: '#000',
					fontSize: 14,
				}
			},
			colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
			landType: [],
			startCharts: null,
			//假数据 
			moydata1: [  //接收全国上市公司投资省份来源 金额占比
				{ value: 446.62, name: '广东省', num: 64 },
				{ value: 294.58, name: '辽宁省', num: 9 },
				{ value: 165.78, name: '内蒙古自治区', num: 3 },
				{ value: 67.82, name: '浙江省', num: 24 },
				{ value: 53.32, name: '北京市', num: 29 },
				{ value: 45.69, name: '福建省', num: 11 },
				{ value: 34.61, name: '江苏省', num: 16 },
				{ value: 23.3, name: '河南省', num: 5 },
				{ value: 21.44, name: '重庆市', num: 1 },
				{ value: 21.12, name: '贵州省', num: 5 },
				{ value: 67.96, name: '其他', num: 25 },
			],
			moydata2: [
				{ name: '深圳市', value: 346.26 },
				{ name: '鞍山市', value: 276.8 },
				{ name: '巴彦淖尔市', value: 165.78 },
				{ name: '北京市', value: 53.32 },
				{ name: '佛山市', value: 34.69 },
				{ name: '杭州市', value: 33.53 },
				{ name: '广州市', value: 27.3 },
				{ name: '宁波市', value: 26.35 },
				{ name: '重庆市', value: 21.44 },
				{ name: '铜仁市', value: 20.8 },
				{ name: '其他', value: 92.53 },
			],
			moydata3: [
				{ name: '金属', value: 867.84 },
				{ name: '装备制造', value: 492.61 },
				{ name: '能源电力', value: 212.08 },
				{ name: '化工行业', value: 211.13 },
				{ name: '信息技术及服务', value: 205.32 },
				{ name: '医疗医药', value: 119.5 },
				{ name: '非金属', value: 83.1 },
				{ name: '环保水务', value: 82.84 },
				{ name: '商贸', value: 77.65 },
				{ name: '农林牧渔', value: 73.4 },
				{ name: '其他', value: 265.23 },
			],
			moenydata: [  //接收全国上市公司投资省份来源 数值 
				{ city: '北京市', num: 2, money: 10.16 },
				{ city: '江西省', num: 5, money: 9 },
				{ city: '天津市', num: 8, money: 16.4 },
				{ city: '宁夏', num: 5, money: 35.18 },
				{ city: '江苏省', num: 42, money: 95.31 },
			],
			moenydata2: [  //接收全国上市公司投资城市来源 数值
				{ city: '重庆市', num: 5, money: 9 },
				{ city: '北京市', num: 2, money: 10.16 },
				{ city: '天津市', num: 8, money: 16.4 },
				{ city: '银川市', num: 4, money: 34.78 },
				{ city: '泰州市', num: 32, money: 88.51 },
			],
			moenydata3: [
				{ city: '农林牧渔', num: 4, money: 3.23 },
				{ city: '金融行业', num: 3, money: 12.2 },
				{ city: '医疗医药', num: 15, money: 43.4 },
				{ city: '化工行业', num: 11, money: 56.3 },
				{ city: '装备制造', num: 33, money: 66.37 },
			],
			fixassetsdata: [
				{ name: "长沙市", value: 865.97 },
				{ name: "郴州市", value: 802.4 },
				{ name: "株洲市", value: 326.92 },
				{ name: "岳阳市", value: 154.79 },
				{ name: "湘潭市", value: 130.42 },
				{ name: "娄底市", value: 116.31 },
				{ name: "衡阳市", value: 116.28 },
				{ name: "常德市", value: 65.37 },
				{ name: "益阳市", value: 60.18 },
				{ name: "永州市", value: 44.01 },
				{ name: "怀化市", value: 35.95 },
				{ name: "邵阳市", value: 26.42 },
				{ name: "张家界市", value: 17.31 },
				{ name: "湘西土家族苗族自治州", value: 5.51 },
			],
			ydata: [
				{ name: "广东", value: [113.23, 23.16], num: 64 },
				{ name: "辽宁", value: [123.38, 41.8], num: 9 },
				{ name: "内蒙古", value: [111.65, 40.82], num: 5 },
				{ name: "浙江", value: [118.21, 29.11], num: 42 },
				{ name: "北京", value: [116.4, 39.9], num: 2 },
				{ name: "福建", value: [119.3, 26.08], num: 2 },
				{ name: "江苏", value: [118.78, 32.04], num: 2 },
				{ name: "河南", value: [113.65, 34.76], num: 2 },
				{ name: "重庆", value: [106.54, 29.59], num: 2 },
				{ name: "贵州", value: [106.71, 26.57], num: 2 },
				{ name: "上海", value: [121.48, 31.22], num: 2 },
				{ name: "江西", value: [115.89, 28.68], num: 2 },
				{ name: "河北", value: [114.52, 38.05], num: 2 },
				{ name: "安徽", value: [117.27, 31.86], num: 2 },
			],
			investmentlist: [],
			zbdata: [],
			zd: [113, 28.21], //大地图终点坐标
			startYear:"",
			endYear: "",
			chartsHeight: 360,
		}
	},
	props: {
		msg: String,
	},
	computed: {
		defaultOption() {
			return {
				step: 0.7, // 数值越大速度滚动越快
				limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			}
		}
	},

	mounted() {
		let jdata = require('../../../../public/map/geo.json');  //引入json文件
		document.getElementById('app').style.background = this.bgcolor;
		this.userdata = this.getuseriformation();
		this.getajasdata();
		// this.PiechartFun('zsxm_province_money', this.moydata1); //接收全国上市公司投资省份来源 金额占比
		// this.PiechartFun('zsxm_city_money', this.moydata2); //接收全国上市公司投资城市来源 金额占比
		// this.rankFun('zsxm_industry_money', this.moydata3);//接收全国上市公司投资行业分布 金额占比
		// this.rankFun('zsxm_provincerank', this.fixassetsdata); //接收投资金额全省排名
		// this.chianmapFun('zsxm_map', this.moydata1, this.ydata); //地图
		this.chartsHeight = document.body.clientHeight/2.5;
		console.log('页面高度', this.chartsHeight);
	},
	methods: {

		yearChange(list) {
			this.startYear = list.startYear, this.endYear = list.endYear;
			// console.log(list);
			this.getajasdata();
		},
		getajasdata() {
			var _this = this;
			this.bus.$emit('loading', true);
			console.log(this.title);
			this.$axios.get(this.$api.cyl.GovProvinceChart.Land()+'?startYear='+this.startYear+'&endYear='+this.endYear, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log('调试信息，停止执行', res);
				if (res.data.success) {
					var datd = res.data.data;
					_this.moydata1 = res.data.data.province;
					_this.moydata2 = res.data.data.city;
					_this.moydata3 = res.data.data.industry;
					_this.investmentlist = res.data.data.investList;
					_this.PiechartFun('zsxm_province_money', res.data.data.province);  //接收全国上市公司投资省份来源 
					_this.PiechartFun('zsxm_city_money', res.data.data.sourceCity); //接收全国上市公司投资城市来源 
					_this.rankFun('zsxm_industry_money', res.data.data.industry, 2); //接收上市公司投资行业分布
					_this.rankFun('zsxm_provincerank', res.data.data.targetCity, 1); //接收投资金额全省排名
					_this.chianmapFun('zsxm_map', res.data.data.map, _this.ydata); //地图
					_this.bus.$emit('loading', false);
				}
			}).catch(function (error) {
				//请求失败处理 console.log(error);
			});
		},

		//1大地图
		chianmapFun(el, data) {
			console.log('地图', this.zd, data);
			var _this = this;
			var lineData = [], scdata = [];
			var lagData = this.$geoJson;

			for (var i = 0; i < data.length; i++) {
				// if (data[i].name == '内蒙古自治区' || data[i].name == '黑龙江省') {
				// 	data[i].name = data[i].name.substr(0, 3); //匹配前三字
				// } else {
				// 	data[i].name = data[i].name.substr(0, 2); //匹配前两字
				// }
				for (let key in lagData) {

					if (typeof lagData[key] === 'object' && lagData[key] !== null) {
						if (data[i].name.indexOf(key) !== -1) {
							console.log('匹配到的坐标', data[i].name, key);
							lineData.push({
								fromName: data[i].name,
								toName: '湖南',
								coords: [lagData[key], _this.zd],
								value: 2,
								num: data[i].num,
								money: data[i].money,
								moneyUnit: data[i].moneyUnit,
								sizeUnit: data[i].sizeUnit,
								size: data[i].size,
							})
							scdata.push({
								name: data[i].name,
								value: lagData[key],
								num: data[i].num,
								money: data[i].money,
								moneyUnit: data[i].moneyUnit,
								sizeUnit: data[i].sizeUnit,
								size: data[i].size,
							});
						}
					}
				}



			}
			console.log('lineData', lineData, data);
			// return;
			var myChart = echarts.init(document.getElementById(el));
			// JSON文件(地图数据)路径
			var loadedDataURL = 'map/china.json';
			let cityCode = 'china';
			// 显示加载动画效果,可以在加载数据前手动调用该接口显示加载动画，在数据加载完成后调用 hideLoading 隐藏加载动画。
			// myChart.showLoading();
			let mapName = cityCode;
			$.getJSON(loadedDataURL, function (geoJson) {
				// console.log('geoJson:', geoJson)
				// 注册地图名字(tongren)和数据(geoJson) 
				echarts.registerMap(mapName, geoJson);
				// 隐藏动画加载效果。
				myChart.hideLoading();
				// 图表配置项
				var option = {
					backgroundColor: this.bgcolor,
					selectedMode: 'multiple', // 选中效果固话
					tooltip: { // 提示框
						show: true,
						trigger: 'item',
						formatter: function (params) {
							// console.log(params)
							return params.name;
						}
					},
					geo: {
						map: mapName,
						// aspectScale: .9,
						// layoutCenter: ['50%', '50%'],
						// layoutSize: '110%',
						silent: true,
						roam: false,
						zoom: 1.18,
						center: [105.97, 37.0],
						// z: 0,
						itemStyle: {
							normal: {
								areaColor: 'rgba(0, 0, 0, 1)', //底图背景色
								shadowColor: 'rgba(0, 0, 0, 1)',
								shadowBlur: 0,
								shadowOffsetX: 0,
								shadowOffsetY: 0,
								borderColor: '#07232c',
								borderWidth: 0.5,
							},
							emphasis: {
								areaColor: 'rgba(0,0,0,1)',
								borderWidth: 1,
								color: 'green',
								label: {
									show: true,
								},
							},
						},

					},
					series: [{
						name: 'map',
						type: "map", // map3D / map
						map: mapName,
						zoom: 1.18,
						roam: false,
						label: { // 标签的相关设置
							show: true, // (地图上的城市名称)是否显示标签 [ default: false ]
							// distance: 5, // 标签距离图形的距离，在三维的散点图中这个距离是屏幕空间的像素值，其它图中这个距离是相对的三维距离
							//formatter:, // 标签内容格式器
							textStyle: { // 标签的字体样式
								color: '#ffffff', // 地图初始化区域字体颜色 
								fontSize: 14, // 字体大小
								opacity: 1, // 字体透明度 
							},
							emphasis: {
								show: true,
								color: '#ffffff',
							}
						},
						itemStyle: { // 三维地理坐标系组件 中三维图形的视觉属性，包括颜色，透明度，描边等。
							// areaColor: 'rgba(95,158,160,0.4)', // 地图板块的颜色
							areaColor: '#2e579d', // 地图板块的颜色
							opacity: 1, // 图形的不透明度 [ default: 1 ]
							borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
							borderColor: '#fff' // 图形描边的颜色。[ default: #333 ]
						},
						emphasis: {
							show: true,
							itemStyle: {
								areaColor: '#0e2240', // 地图板块的颜色
								opacity: 1, // 图形的不透明度 [ default: 1 ]
								borderWidth: 1, // (地图板块间的分隔线)图形描边的宽度。加上描边后可以更清晰的区分每个区域 [ default: 0 ]
								borderColor: '#fff', // 图形描边的颜色。[ default: #333 ]

							}
						},
						data: data,
						tooltip: {
							show: false,
						},
					},
					{
						type: "effectScatter",       //带有涟漪特效动画的散点（气泡）图。
						data: scdata,
						coordinateSystem: 'geo',     //'geo',使用地理坐标系/ 该系列使用的坐标系，'cartesian2d',使用二维的直角坐标系/'polar'使用极坐标系，
						rippleEffect: {              //涟漪特效相关配置。
							scale: 6,        // 波纹的最大缩放比例
							color: '#e4bb38',        //涟漪颜色
							period: 3,       // 动画的周期，秒数
							brushType: 'fill'      // 波纹样式：'stroke'  ，'fill'
						},
						symbol: '',						   //散点形状设置symbol: 'circle’, ‘rect’, ‘roundRect’, ‘triangle’, ‘diamond’, ‘pin’, 'arrow’
						symbolSize: '5',
						itemStyle: {
							normal: {
								color: '#e4bb38',		//圆点颜色
								shadowColor: '',   //圆点阴影
								// shadowBlur:3,
								// shadowOffsetX:1,
								// shadowOffsetY:2
							}
						},
					},
					{
						type: 'lines', // 线数据
						zlevel: 1,
						effect: {
							show: true,
							period: 0.8, // 箭头指向速度，值越小速度越快
							trailLength: 0.01, // 特效尾迹的长度。取从 0 到 1 的值，数值越大尾迹越长。
							symbol: 'triangle', // 特效图形的标记。
							symbolSize: 5 // 特效标记的大小
						},
						lineStyle: {
							normal: {
								width: 2, // 尾迹线条宽度
								color: '#e4bb38', // 线颜色
								opacity: 0, // 尾迹线条透明度
								curveness: 0.2,// 边的曲度，支持从 0 到 1 的值，值越大曲度越大。 
							}
						},
						tooltip: { //提示框组件。
							show: true,
							alwaysShowContent: true,
							hoverAnimation: true,
							trigger: 'item', //触发类型 散点图
							enterable: true, //鼠标是否可进入提示框
							transitionDuration: 1, //提示框移动动画过渡时间
							triggerOn: 'click',
							borderWidth: '1px',
							borderRadius: '4',
							// borderColor: '#00B2AC',
							backgroundColor: "rgba(0,0,0,.6)",
							textStyle: {
								color: 'rgba(255,255,255,1)'
							},
							padding: [10, 10],
							formatter: function (params) {
								var result = '';
								if (!isNaN(params.value)) {
									result = params.data.fromName + '<br>' +
										// '投资金额（'+ params.data.moneyUnit+'）：' + params.data.money + '<br>' +
										'拿地面积（' + params.data.sizeUnit + '）：' + params.data.size;
								} else {
									result = '' + params.name;
								}
								// console.log(params);
								return result;
							},

						},
						data: lineData,
					},

					],
				};
				option.series[0].center = [105.87, 36.8];
				// 设置图表实例的配置项以及数据，万能接口，所有参数和数据的修改都可以通过setOption完成，ECharts 会合并新的参数和数据，然后刷新图表。
				myChart.setOption(option);
			});
		},


		//饼图fn
		PiechartFun(el, data) {
			console.log('进入饼图');
			var charPie3currentIndex = 0,
				isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var regionalchart = echarts.init(document.getElementById(el));
			for (var i = 0; i < data.length; i++) {
				if (data[i].name != '湖南省') {
					data[i].value = data[i].size;
				}
			}
			var _this = this;
			var option = {
				title: {
					text: ' ',
				},
				tooltip: {
					trigger: 'item'
				},
				// legend: {top: 'center',right:'15%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:6,itemHeight:6, icon:'circle'	//图例圆形
				// },
				series: [{
					name: '',
					type: 'pie',
					radius: '55%',
					// center: ["52%", "50%"],
					data: data,
					label: {
						show: true,
						color: '#eee',
						fontSize: 12,
						position: 'outside',
						formatter: '{b} : {d}%',
					},
					tooltip: { //提示框组件。
						show: true,
						alwaysShowContent: true,
						hoverAnimation: true,
						trigger: 'item', //触发类型 散点图
						enterable: true, //鼠标是否可进入提示框
						transitionDuration: 1, //提示框移动动画过渡时间
						triggerOn: 'click',
						borderWidth: '1px',
						borderRadius: '4',
						// borderColor: '#00B2AC',
						backgroundColor: "rgba(0,0,0,.6)",
						textStyle: {
							color: 'rgba(255,255,255,1)'
						},
						padding: [10, 10],
						formatter: function (params) {
							var result = '';
							let sizeNum = '';
							if (!isNaN(params.value)) {
								result =
									// '投资金额（'+ params.data.moneyUnit+'）：' + params.data.money + '<br>' +
									'拿地面积（' + params.data.sizeUnit + '）：' + params.data.size;
							} else {
								result = params.name;
							}
							// console.log(params);
							return result;
						},

					},
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
					}
				}]
			};
			regionalchart.setOption(option);
			setTimeout(function () {
				window.onresize = function () {
					regionalchart.resize();
				}
			}, 200)
		},

		//1
		numFun(el, data) {
			console.log(data);
			var projectchart = echarts.init(document.getElementById(el));
			// var yData = ['2016年', '2017年', '2018年', '2019年','2020年'];
			var _this = this,
				xdata1 = [],
				xdata2 = [],
				yData = [];
			for (var i = 0; i < data.length; i++) {
				xdata1.push(data[i].money);
				xdata2.push(data[i].num);
				// data[i].city=data[i].name;
				yData.push(data[i].name);
			}
			var option = {
				title: {
					text: ''
				},
				tooltip: {
					formatter: "{b}：{a}{c}",
					confine: true, //提示框被遮挡  是否将 tooltip 框限制在图表的区域内 
				},
				grid: [{ // 左侧对应坐标系
					show: false,
					left: '10%',
					top: '10%',
					bottom: '10%',
					width: '40%'
				},
				{ // 右侧对应坐标系
					show: false,
					left: '51%',
					top: '10%',
					bottom: '10%',
					width: '40%'
				},
				{ // 用来显示的坐标系
					show: false,
					left: '15%',
					top: '10%',
					bottom: '10%',
					width: '80%'
				}
				],
				// x轴是度量，y轴是维度
				xAxis: [{ // 左侧轴
					type: 'value',
					inverse: true,
					min: 0,
					// max: val => {
					//     return Math.floor((val.max) * 1.1);
					// }, 
					axisLine: { //轴线
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false, //轴标签
						textStyle: {
							color: '#999',
							fontSize: 12
						}
					},
					splitLine: {
						show: false
					}
				},
				{ // 右侧轴
					type: 'value',
					gridIndex: 1,
					min: 0,
					// max: val => {
					//     return Math.floor((val.max) * 1.1);
					// },
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						textStyle: {
							color: '#999',
							fontSize: 12
						}
					},
					splitLine: {
						show: false
					}
				},
				{ // 最左侧y轴对应x轴
					gridIndex: 2,
					name: 'x',
					nameLocation: 'center',
					nameGap: 40, // 与坐标轴距离
					nameTextStyle: {
						color: '#999999',
						fontSize: 12
					},
					axisLine: {
						show: false
					}
				}
				],
				yAxis: [{
					type: 'category',
					position: 'right',
					axisLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						margin: 0
					},
					data: yData
				},
				//右侧y轴
				{
					gridIndex: 1,
					type: 'category',
					position: 'left',
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						show: false
					},
					data: yData
				},
				{
					name: '',
					gridIndex: 2,
					type: 'category',
					position: 'left',
					nameLocation: 'end',
					nameGap: 25, // 与坐标轴距离
					nameTextStyle: {
						color: '#999999',
						fontSize: 12
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						textStyle: {
							color: '#000',
							fontSize: 12
						}
					},
					data: yData
				}
				],
				series: [{
					name: '投资金额(亿元)',
					type: 'bar',
					xAxisIndex: 0,
					yAxisIndex: 0,
					// barWidth: '20%',
					itemStyle: { //通常情况下：
						normal: {
							//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
							// color: function(params) {
							// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518','#a8c3ef','#e98eef','#efb1a4','#ef6e2d','#00ffff','#ecef15','#aa0000','#005500','#55557f','#5500ff','#ffff7f','#55aaff','#b1efaa','#aa55ff','#aaaa7f','#6a5bef',];
							// 	return colorList[params.dataIndex];
							// }
							// color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}
						},
					},
					label: {
						normal: {
							show: false,
							position: 'left', //显示顶部数据
							color: '#fff',
						}
					},
					data: xdata1,
					// barCategoryGap:'5%',
				},
				{
					name: '投资数量（个）',
					type: 'bar',
					xAxisIndex: 1,
					yAxisIndex: 1,
					// barMaxWidth: '20%',
					itemStyle: { //通常情况下：
						normal: {
							//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
							// color: function(params) {
							// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518','#6a5bef',];
							// 	return colorList[params.dataIndex];
							// }
							// color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}
						},
					},
					label: {
						normal: {
							show: false,
							position: 'right', //显示顶部数据
							color: '#fff',
						}
					},
					data: xdata2,
				}
				]
			};
			projectchart.setOption(option);
		},

		//2
		numFun2(el, data) {
			var projectchart = echarts.init(document.getElementById(el));
			// var yData = ['2016年', '2017年', '2018年', '2019年','2020年'];
			var _this = this,
				xdata1 = [],
				xdata2 = [],
				yData = [];
			for (var i = 0; i < data.length; i++) {
				xdata1.push(data[i].money);
				xdata2.push(data[i].num);
				yData.push(data[i].name);
			}
			var option = {
				title: {
					text: ''
				},
				tooltip: {
					formatter: "{b}：{a}{c}"
				},
				grid: [{ // 左侧对应坐标系
					show: false,
					left: '10%',
					top: '10%',
					bottom: '10%',
					width: '40%'
				},
				{ // 右侧对应坐标系
					show: false,
					left: '51%',
					top: '10%',
					bottom: '10%',
					width: '40%'
				},
				{ // 用来显示的坐标系
					show: false,
					left: '15%',
					top: '10%',
					bottom: '10%',
					width: '80%'
				}
				],
				// x轴是度量，y轴是维度
				xAxis: [{ // 左侧轴
					type: 'value',
					inverse: true,
					min: 0,
					// max: val => {
					//     return Math.floor((val.max) * 1.1);
					// }, 
					axisLine: { //轴线
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false, //轴标签
						textStyle: {
							color: '#999',
							fontSize: 12
						}
					},
					splitLine: {
						show: false
					}
				},
				{ // 右侧轴
					type: 'value',
					gridIndex: 1,
					min: 0,
					// max: val => {
					//     return Math.floor((val.max) * 1.1);
					// },
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						textStyle: {
							color: '#999',
							fontSize: 12
						}
					},
					splitLine: {
						show: false
					}
				},
				{ // 最左侧y轴对应x轴
					gridIndex: 2,
					name: 'x',
					nameLocation: 'center',
					nameGap: 40, // 与坐标轴距离
					nameTextStyle: {
						color: '#999999',
						fontSize: 12
					},
					axisLine: {
						show: false
					}
				}
				],
				yAxis: [{
					type: 'category',
					position: 'right',
					axisLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						margin: 0
					},
					data: yData
				},
				//右侧y轴
				{
					gridIndex: 1,
					type: 'category',
					position: 'left',
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						show: false
					},
					data: yData
				},
				{
					name: '',
					gridIndex: 2,
					type: 'category',
					position: 'left',
					nameLocation: 'end',
					nameGap: 25, // 与坐标轴距离
					nameTextStyle: {
						color: '#999999',
						fontSize: 12
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						textStyle: {
							color: '#000',
							fontSize: 12
						}
					},
					data: yData
				}
				],
				series: [{
					name: '投资金额(亿元)',
					type: 'bar',
					xAxisIndex: 0,
					yAxisIndex: 0,
					// barWidth: '20%',
					itemStyle: { //通常情况下：
						normal: {
							//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
							// color: function(params) {
							// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518','#6a5bef'];
							// 	return colorList[params.dataIndex];
							// }
						},
					},
					label: {
						normal: {
							show: false,
							position: 'left', //显示顶部数据
							color: '#fff',
						}
					},
					data: xdata1,
					// barCategoryGap:'5%',
				},
				{
					name: '投资数量（个）',
					type: 'bar',
					xAxisIndex: 1,
					yAxisIndex: 1,
					// barMaxWidth: '20%',
					itemStyle: { //通常情况下：
						normal: {
							//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
							// color: function(params) {
							// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518',
							// 	'#6a5bef'];
							// 	return colorList[params.dataIndex];
							// }
						},
					},
					label: {
						normal: {
							show: false,
							position: 'right', //显示顶部数据
							color: '#fff',
						}
					},
					data: xdata2,
				}
				]
			};
			projectchart.setOption(option);
		},
		//3
		numFun3(el, data) {
			var projectchart = echarts.init(document.getElementById(el));
			// var yData = ['2016年', '2017年', '2018年', '2019年','2020年'];
			var _this = this,
				xdata1 = [],
				xdata2 = [],
				yData = [];
			for (var i = 0; i < data.length; i++) {
				xdata1.push(data[i].money);
				xdata2.push(data[i].num);
				yData.push(data[i].name);
			}
			var option = {
				title: {
					text: ''
				},
				tooltip: {
					formatter: "{b}：{a}{c}"
				},
				grid: [{ // 左侧对应坐标系
					show: false,
					left: '10%',
					top: '10%',
					bottom: '10%',
					width: '40%'
				},
				{ // 右侧对应坐标系
					show: false,
					left: '51%',
					top: '10%',
					bottom: '10%',
					width: '40%'
				},
				{ // 用来显示的坐标系
					show: false,
					left: '15%',
					top: '10%',
					bottom: '10%',
					width: '80%'
				}
				],
				// x轴是度量，y轴是维度
				xAxis: [{ // 左侧轴
					type: 'value',
					inverse: true,
					min: 0,
					// max: val => {
					//     return Math.floor((val.max) * 1.1);
					// }, 
					axisLine: { //轴线
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false, //轴标签
						textStyle: {
							color: '#999',
							fontSize: 12
						}
					},
					splitLine: {
						show: false
					}
				},
				{ // 右侧轴
					type: 'value',
					gridIndex: 1,
					min: 0,
					// max: val => {
					//     return Math.floor((val.max) * 1.1);
					// },
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						textStyle: {
							color: '#999',
							fontSize: 12
						}
					},
					splitLine: {
						show: false
					}
				},
				{ // 最左侧y轴对应x轴
					gridIndex: 2,
					name: 'x',
					nameLocation: 'center',
					nameGap: 40, // 与坐标轴距离
					nameTextStyle: {
						color: '#999999',
						fontSize: 12
					},
					axisLine: {
						show: false
					}
				}
				],
				yAxis: [{
					type: 'category',
					position: 'right',
					axisLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						margin: 0
					},
					data: yData
				},
				//右侧y轴
				{
					gridIndex: 1,
					type: 'category',
					position: 'left',
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						show: false
					},
					data: yData
				},
				{
					name: '',
					gridIndex: 2,
					type: 'category',
					position: 'left',
					nameLocation: 'end',
					nameGap: 25, // 与坐标轴距离
					nameTextStyle: {
						color: '#999999',
						fontSize: 12
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#ccc'
						}
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						show: false,
						textStyle: {
							color: '#000',
							fontSize: 12
						}
					},
					data: yData
				}
				],
				series: [{
					name: '投资金额(亿元)',
					type: 'bar',
					xAxisIndex: 0,
					yAxisIndex: 0,
					// barWidth: '20%',
					itemStyle: { //通常情况下：
						normal: {
							//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
							// color: function(params) {
							// 	var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518',
							// 	'#6a5bef','#c1a5d5'];
							// 	return colorList[params.dataIndex];
							// }
						},
					},
					label: {
						normal: {
							show: false,
							position: 'left', //显示顶部数据
							color: '#fff',
						}
					},
					data: xdata1,
					// barCategoryGap:'5%',
				},
				{
					name: '投资数量（个）',
					type: 'bar',
					xAxisIndex: 1,
					yAxisIndex: 1,
					// barMaxWidth: '20%',
					itemStyle: { //通常情况下：
						normal: {
							//每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
							// color: function(params) {
							// 	 var colorList = ['#5689ef', '#55cea1', '#596c8e', '#eab518',
							// 	'#6a5bef','#c1a5d5'];
							// 	return colorList[params.dataIndex];
							// }
						},
					},
					label: {
						normal: {
							show: false,
							position: 'right', //显示顶部数据
							color: '#fff',
						}
					},
					data: xdata2,
				}
				]
			};
			projectchart.setOption(option);
		},


		//接收投资金额全省排名
		rankFun(el, data, type) {
			var charPie3currentIndex = 0,
				isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var chart = echarts.init(document.getElementById(el));
			var _this = this,
				xline = [],
				seriesline = [];
			var datalen = data.length - 1;
			data = sortKey(data, 'size', 1);
			for (var i = 0; i < data.length; i++) {
				// xline.push(data[datalen - i].city);
				// seriesline.push(data[datalen - i].data);
				if (i < 14) {
					xline.unshift(data[i].name);
					seriesline.unshift(data[ i].size);
				}
			};
			// console.log(data,xline,seriesline)
			var option = {
				title: {
					text: "",
					left: 25,
					top: 20,
					textStyle: {
						color: '#eee',
						fontSize: 16
					}
				},
				tooltip: {
					formatter: "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff'></span>{b}：{c} （亩）"
				},
				color: _this.colors,
				grid: {
					x: type == 1 ? 78 : 200,
					y: 10,
					x2: 50,
					y2: 20,
					show: true,
					borderWidth: 0,
				},
				label: {
					show: false,
					position: 'right',
					valueAnimation: true,
					color: '#fff',
					formatter: '{@score}' + '亩'
				},
				xAxis: {
					type: 'value',
					axisTick: {
						show: false
					},
					boundaryGap: [0, 0.01],
					splitLine: {
						show: false
					},
					axisLabel: {
						fontSize: 12,
						color: '#eee'
					}
				},
				yAxis: {
					type: 'category',
					splitLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLine: {
						show: true
					},
					data: xline,
					axisLabel: {
						fontSize: 12,
						color: '#eee'
					}
				},
				series: [{
					data: seriesline,
					type: 'bar',
					barWidth: 20,
				}]
			};
			chart.setOption(option);
			 
		},
	}
}
</script>

<style scoped="scoped">
#app {
	background-color: #041034;
}

@import url('/src/css/dataswiper.css');
</style>
